import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.mobile.css';

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // 開く
  const open = () => setIsOpen(true);

  // 閉じ始め（closingをONにしてからopenを外す）
  const startClose = () => {
    if (!isOpen) return;
    setIsClosing(true);
    setIsOpen(false); // transform が閉じ側へ遷移開始
  };

  // トグル
  const toggle = () => (isOpen ? startClose() : open());

  // transform のアニメ完了で closing をOFF
  const handleTransitionEnd = (e) => {
    if (e.propertyName !== 'transform') return;
    if (!isOpen && isClosing) setIsClosing(false);
  };

  // ドロワーに付与するクラス
  const drawerClass =
    `sidebar left drawer ${isOpen ? 'open' : ''} ${isClosing ? 'closing' : ''}`;

  return (
    <>
      {/* 768px以下で表示する固定ヘッダー */}
      <header className="mobile-header" role="banner">
        <button
          className={`mh-burger ${isOpen ? 'active' : ''}`}
          aria-label={isOpen ? 'メニューを閉じる' : 'メニューを開く'}
          aria-expanded={isOpen}
          onClick={toggle}
        >
          <span /><span /><span />
        </button>

        <Link to="/dashboard" className="mh-logo" onClick={startClose} aria-label="トップへ">
          <img src="/logo-2.png" alt="ロゴ" />
        </Link>
      </header>

      {/* バックドロップ（開いている間と閉じアニメ中は表示） */}
      {(isOpen || isClosing) && (
        <div className={`mh-backdrop ${isOpen ? 'show' : ''}`} onClick={startClose} />
      )}

      {/* サイドバー：PCは既存、768px以下はドロワー化（transformでスライド） */}
      <aside
        className={drawerClass}
        aria-hidden={!isOpen && !isClosing}
        onTransitionEnd={handleTransitionEnd}
      >
        {/* ドロワー内ロゴ（スマホでは open/closing 中はCSSで非表示） */}
        <div className="dashboard-logo sb-drawer-brand">
          <Link to="/dashboard" onClick={startClose}>
            <img src="/logo-2.png" alt="ロゴ" />
          </Link>
        </div>

        <nav>
          <li>
            <Link to="/dashboard" className="nav-link" onClick={startClose}>
              <img src="/all.png" alt="概要" className="nav-icon" />
              概要
            </Link>
          </li>
          <li>
            <Link to="/videolist" className="nav-link" onClick={startClose}>
              <img src="/videos.png" alt="動画" className="nav-icon" />
              動画
            </Link>
          </li>
          <li>
            <Link to="/memo" className="nav-link" onClick={startClose}>
              <img src="/memo.png" alt="メモ" className="nav-icon" />
              メモ
            </Link>
          </li>
          <li>
            <Link to="/setting" className="nav-link" onClick={startClose}>
              <img src="/setting.png" alt="設定" className="nav-icon" />
              設定
            </Link>
          </li>
        </nav>
      </aside>
    </>
  );
}
